import styled from 'styled-components';
import { Wrapper } from '../../PulseCheck.styles';

export const StyledWrapper = styled(Wrapper)({
  paddingTop: 0,
  alignItems: 'unset',
  justifyContent: 'unset',
  overflowX: 'clip',
  minHeight: 1100,
});
